import { combineReducers } from 'redux'

import batteries from './print/batteries'
import control from './print/control'
import controlGroup from './print/controlGroup'
import full_inventory from './print/full_inventory'
import inventory from './print/inventory'
import inventory_to_fill from './print/inventory_to_fill'
import owner from './print/owner'
import product from './print/product'
import pipes from './print/pipes'

export default combineReducers({
  batteries,
  control,
  controlGroup,
  full_inventory,
  inventory,
  inventory_to_fill,
  owner,
  product,
  pipes
})



// WEBPACK FOOTER //
// ./src/reducers/root/print.js